export const getById = (state) => (id) => {
  return state.devices.find(device => device.id === id)
}
